/**
 * Block: Image / video
 *
 * When the block has both a video and an image, the image is shown as a poster
 * with a play button over it (see block-image-video.twig). Clicking the poster
 * reveals the native controls and starts playback.
 */

document.querySelectorAll('.image-video-block .figure-wrapper.has-video').forEach((figure) => {
  const poster = figure.querySelector('.video-poster');
  const video = figure.querySelector('video');
  if (!poster || !video) return;

  poster.addEventListener('click', () => {
    figure.classList.add('is-playing');
    video.setAttribute('controls', '');
    const played = video.play();
    if (played && played.catch) played.catch(() => { /* ignore play() rejection */ });
  });
});
